
import { Component, computed, inject, OnInit, signal } from '@angular/core';

import { ApprofondimentoComponent, ApprofondimentoStep, ButtonComponent, LoaderComponent } from '@mic-ac/ui-kit';

import { Router } from '@angular/router';
import { AuthServiceService } from '../../../../core/services/auth-service/auth-service.service';
import { ResponseUser, AccreditamentoParams, Accreditamento } from '../../../../shared/models/utente';
import { ContactRequestModalComponent } from '../../../contact/contact-request-modal.component';

@Component({
    selector: 'app-user-req',
    imports: [LoaderComponent, ApprofondimentoComponent, ButtonComponent, ContactRequestModalComponent],
    templateUrl: './user-req.component.html',
    styleUrl: './user-req.component.css'
})
export class UserReqComponent implements OnInit {


  #registerService = inject(AuthServiceService);
  #router = inject(Router);

  userProfile = signal<ResponseUser>({} as ResponseUser)
  loading = signal(true);
  showAlert = signal(true);
  accreditamentoAttivo = signal<Accreditamento | null>(null);
  showContactModal = signal(false);

  alertMessage = computed(() => {
    const acc = this.accreditamentoAttivo();
    const user = this.userProfile().element;

    if (!acc) {
      if (user?.emailConfirmed) {
        return 'Nessuna richiesta di accreditamento sottomessa. Procedi con il download e l\'invio del modulo per richiedere l\'abilitazione al servizio.';
      }
      return 'Per scaricare la form e richiedere il servizio è necessario aver confermato la mail fornita.';
    }

    const dataRichiesta = acc.dataRicezione ? new Date(acc.dataRicezione).toLocaleDateString('it-IT') : 'N/D';

    switch (acc.esito) {
      case 'SCARTATA':
        return `La tua richiesta di accreditamento effettuata in data ${dataRichiesta}, non è andata a buon fine, verifica i campi inseriti e invia nuovamente la richiesta.`;
      case 'RIFIUTATA':
        return `Siamo spiacenti, la tua richiesta di accreditamento effettuata in data ${dataRichiesta} è stata respinta. Al momento non è possibile accedere al servizio di gestione collezioni. Per ulteriori informazioni contatta l'amministrazione o verifica i campi inseriti e invia nuovamente la richiesta.`;
      case 'APPROVATA':
        return 'La tua richiesta è stata approvata.';
      default:
        return 'La tua richiesta di accreditamento è in fase di valutazione.';
    }
  });

  alertClass = computed(() => {
    const acc = this.accreditamentoAttivo();
    const user = this.userProfile().element;

    if (!acc) {
      return (user?.emailConfirmed) ? 'wgt-alert-info' : 'wgt-alert-warning';
    }
    if (acc.esito === 'RIFIUTATA') return 'wgt-alert-error';
    if (acc.esito === 'SCARTATA') return 'wgt-alert-warning';
    if (acc.esito === 'APPROVATA') return 'wgt-alert-success';
    return 'wgt-alert-warning';
  });
  alertIcon = computed(() => {
    const acc = this.accreditamentoAttivo();
    const user = this.userProfile().element;

    if (!acc) {
      return (user?.emailConfirmed) ? 'assets/icons/Vector.svg' : 'assets/icons/warning.svg';
    }
    if (acc.esito === 'RIFIUTATA') return 'assets/icons/error.svg';
    if (acc.esito === 'SCARTATA') return 'assets/icons/warning.svg';
    if (acc.esito === 'APPROVATA') return 'assets/icons/confirm.svg';
    return 'assets/icons/warning.svg';
  });
    // ── Steps ────────────────────────────────────────────────────────────────
  readonly stepsTitle = 'Come aderire al servizio - passo per passo';
  readonly steps: ApprofondimentoStep[] = [
    {
      description:
        'Scarica il modulo di richiesta accreditamento.',
        iconUrl: './assets/icons/Icon.svg'
    },
    {
      description:
        'Compilalo in tutte le sue parti e salvalo in formato PDF. Non è necessario apporre una firma autografa o digitale',
        iconUrl: './assets/icons/Icon-1.svg'
    },
    {
      description:
        'Invia il modulo all\'indirizzo <strong>mappadelpatrimonio@cineca.it</strong> da una casella PEC valida.',
      iconUrl: './assets/icons/Icon-2.svg',
    },
    { description: 'Attendi la notifica relativa all’esito della richiesta. Una volta approvato l’accreditamento, accedi all’Area riservata e avvia le attività di censimento.',
      iconUrl: './assets/icons/Icon-3.svg'
    },
  ];

  ngOnInit(): void {
    this.getProfile();
  }

  goToOtpConfirmation(): void {
    const email = this.userProfile().element?.email;
    this.#router.navigate(['/register'], { queryParams: { otpStage: true, email } });
  }


  getAccreditamentoState() {
    const params: AccreditamentoParams = {
      paginazione: {
        page: 0,
        totalElementsForPage: 10,
        totalElements: 0,
        totalPages: 0
      },
      order: 'desc',
      orderField: 'dataRicezione'
    };

    this.#registerService.getMicAuthState(params).subscribe({
      next: (res) => {
        console.log('Stato accreditamento:', res);
        if (res.elements && res.elements.length > 0) {
          const lastReq = res.elements[0];
          this.accreditamentoAttivo.set(lastReq);
        }
        this.loading.set(false);
      },
      error: (err) => {
        console.error('Errore recupero stato accreditamento:', err);
        this.loading.set(false);
      }
    })
  }


  downloadForm(): void {
    const link = document.createElement('a');
    link.href = 'assets/forms/modulo_accreditamento.pdf';
    link.download = 'modulo_accreditamento.pdf';
    link.click();
  }

  openContactModal(): void {
    this.showContactModal.set(true);
  }

  closeContactModal(): void {
    this.showContactModal.set(false);
  }

  getProfile() {
    this.#registerService.myProfile().subscribe({
      next: (res) => {

        this.userProfile.set(res)
        this.#registerService.setUser(res);
        this.getAccreditamentoState();
      },
      error: (err) => {},
    })
  }
}
